import {
  REASON_KPI_DISABLED,
  REASON_KPI_REMOVED_FROM_ACTIVITY,
  SUBJECT_ACTIVITY_NAME,
  SUBJECT_KPI_NAME,
} from "../constants/kpiDependencyConflictConstants";
import type { KpiDependencyConflict } from "../types/kpiDependencyConflict";

export function paragraphForKpiConflict(conflict: KpiDependencyConflict): string {
  const { reason, subject, detail } = conflict;
  if (reason === REASON_KPI_REMOVED_FROM_ACTIVITY) {
    const kpiName = subject?.[SUBJECT_KPI_NAME];
    const activityName = subject?.[SUBJECT_ACTIVITY_NAME];
    if (typeof kpiName === "string" && typeof activityName === "string") {
      return `${kpiName} can't be removed from ${activityName}. Calculated KPIs use it in their formula. Keep it on this activity, or change those formulas, then try again.`;
    }
  }
  if (reason === REASON_KPI_DISABLED) {
    const kpiName = subject?.[SUBJECT_KPI_NAME];
    if (typeof kpiName === "string") {
      return `${kpiName} is used by calculated KPIs. Change or remove those formulas, then disable it.`;
    }
  }
  return detail;
}
